import { styled } from "@mui/material";
import { StyledCard } from "../styledCard.styled";

type StyledInvoiceCardProps = {
  opened: boolean;
};

export const StyledInvoiceCard = styled(StyledCard)<StyledInvoiceCardProps>(
  ({ theme, opened }) => ({
    gridArea: opened ? "2 / 1 / 14 / 4" : "8 / 2 / 14 / 3",
    zIndex: opened ? 100 : 0,
    background: theme.color.background,
    [`@media screen and (max-width: ${theme.breakpoints.values.wide}px)`]: {
      paddingBottom: "0",
    ".head": {
      marginBottom: "0",
      padding: ".25rem 1rem",
      h3: {
        fontSize: "1.2rem",
      },
      svg: {
        width: "24px"
      },
    },
  },
  })
);
